class VariantPickerSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-ref="variant-select"]');
    if (!this.select) return;
    this.select.addEventListener('change', this.#handleChange);
    // Synchronise l'état initial (variante présélectionnée)
    this.#syncButton();
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.#handleChange);
  }

  // Remonte le DOM jusqu'à l'ancêtre commun qui contient le quick-add / bouton panier
  // pour ne pas dépendre du nom de classe exact de la carte produit.
  #findScope() {
    let el = this.parentElement;
    while (el) {
      if (
        el.querySelector('quick-add-component') ||
        el.querySelector('[data-ref="add-to-cart-button"]') ||
        el.querySelector('[data-ref="popup-toggle"]')
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return document;
  }

  #syncButton() {
    const option = this.select?.selectedOptions?.[0];
    if (!option) return;
    this.#applyOption(option);
  }

  #applyOption(option) {
    const variantId = option.value;
    const price = option.dataset.price;
    const available = option.dataset.available === 'true';
    const scope = this.#findScope();

    // Cas mono-variante : bouton add-to-cart direct présent dans le DOM
    const addToCartButton = scope.querySelector('[data-ref="add-to-cart-button"]');
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;
      addToCartButton.disabled = !available;
    }

    // Cas multi-variantes : le bouton visible est le toggle de la modale.
    // On mémorise la variante choisie pour que le quick-add l'utilise.
    const popupToggle = scope.querySelector('[data-ref="popup-toggle"]');
    if (popupToggle) {
      popupToggle.dataset.variantId = variantId;
    }

    // Met à jour le prix affiché sur le bouton s'il existe un emplacement dédié
    const priceEl = scope.querySelector('.quick-add-button__price');
    if (priceEl && price) {
      priceEl.textContent = price;
    }
  }

  #handleChange = (event) => {
    const option = event.target.selectedOptions[0];
    if (!option) return;
    this.#applyOption(option);
  };
}

if (!customElements.get('variant-picker-select')) {
  customElements.define('variant-picker-select', VariantPickerSelect);
}
